(function () {
  if (window.stokeBackorderGuardInstalled) return;
  window.stokeBackorderGuardInstalled = true;
  function noticeFor(formId) {
    if (formId === 'CartDrawer-Form') return document.querySelector('#CartDrawer .stoke-cart-backorder');
    if (formId === 'cart') return document.querySelector('#main-cart-footer .stoke-cart-backorder');
    return null;
  }
  function acknowledged(formId) {
    var notice = noticeFor(formId);
    if (!notice) return true;
    var tick = notice.querySelector('.stoke-backorder-ack-input');
    if (tick && tick.checked) return true;
    var error = notice.querySelector('.stoke-backorder-error');
    if (error) error.hidden = false;
    if (tick) {
      tick.focus();
      tick.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    return false;
  }
  document.addEventListener('click', function (e) {
    var button = e.target.closest('#CartDrawer-Checkout, #checkout');
    if (!button) return;
    var formId = button.id === 'CartDrawer-Checkout' ? 'CartDrawer-Form' : 'cart';
    if (!acknowledged(formId)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var formId = e.target && e.target.id;
    if (formId !== 'CartDrawer-Form' && formId !== 'cart') return;
    var submitter = e.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    if (!acknowledged(formId)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.stoke-backorder-ack-input')) return;
    var notice = e.target.closest('.stoke-cart-backorder');
    var error = notice && notice.querySelector('.stoke-backorder-error');
    if (error && e.target.checked) error.hidden = true;
  });
})();